import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() page;
  @Input() disabled = false;
  @Input() collectionSize;
  @Input() noPerPage = 10;
  @Input() maxSize = 3;
  @Input() elementStyle = false;
  @Output() pageChange = new EventEmitter<any>();
  @Input() type = null; // Specifies type if multiple pagination is used in same component;

  pageChanged() {
    if (this.type) {
      this.pageChange.emit({
        page: this.page,
        type: this.type,
      });
    } else {
      this.pageChange.emit(this.page);
    }
  }
}
